var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "match-tab-filters" }, [
    _c("div", { staticClass: "filter-wrap" }, [
      _c("div", { staticClass: "filter-info" }, [
        _c("span", [_vm._v(_vm._s(_vm.translations.select_entry_fee_range))]),
        _vm._v(" "),
        false
          ? _c("a", { staticClass: "filter-guide", attrs: { href: "#" } }, [
              _vm._v(_vm._s(_vm.translations.how_it_works)),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "filters-list" },
        _vm._l(_vm.entry_fee_filter, function (level, index) {
          return _c(
            "li",
            {
              key: index + 1,
              class: [level.is_selected ? "active" : ""],
              on: {
                click: function ($event) {
                  level.is_selected
                    ? function () {
                        return !1
                      }
                    : _vm.setEntryFilterlevel(index)
                },
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.translations.entry_filter_level_labels &&
                      _vm.translations.entry_filter_level_labels[index]
                  ) +
                  "\n      "
              ),
            ]
          )
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }